import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import GET_VALIDATE_TAG_DOMAIN from '../../../../core/GraphQl/Queries/GET_VALIDATE_TAG_DOMAIN.js';

const ValidateTagDomainLoader = ({ url, onResult }) => {
  const { loading, error, data } = useQuery(GET_VALIDATE_TAG_DOMAIN, {
    variables: { url },
  });

  useEffect(() => {
    if (!loading && !error && data) {
      onResult(data);
    }
  }, [loading, error, data, onResult]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return null;
};

export default ValidateTagDomainLoader;
